module.exports = __webpack_public_path__ + "static/plum-landing-eat-a530651bcc2641710a8112c2a5669f62.gif";